import { FieldDefinition } from '~/editor/v2/cards/edit-modal/types';
import {
  cardSubtitleField,
  plainTextCodec
} from '~/editor/v2/cards/templates/textFields';
import { sanitizeBodyForSave, stripHtml } from '~/lib/sanitization';

/**
 * The kicker, title and description a picture card shows with its media, in
 * that order (the kicker above its title), limited as on a text card. A new
 * picture card starts without them. They are template text fields: without
 * the company flag, a picture card's panel edits its media only, as before.
 */
export const pictureCardTextFields: FieldDefinition[] = [
  cardSubtitleField,
  {
    type: 'input',
    name: 'title',
    label: 'Title',
    maxLength: 120,
    placeholder: 'Enter title',
    ...plainTextCodec,
    defaultValue: '',
    templateTextField: true
  },
  {
    type: 'textarea',
    name: 'body',
    label: 'Description',
    maxLength: 1200,
    placeholder: 'Enter description',
    sanitizer: sanitizeBodyForSave,
    deserializer: stripHtml,
    defaultValue: '',
    templateTextField: true
  }
];
